import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface ContinueBarProps {
  label: string;
  onClick: () => void;
  accent?: string;
  disabled?: boolean;
}
export function ContinueBar({
  label,
  onClick,
  accent = '#0F9C8C',
  disabled = false
}: ContinueBarProps) {
  return <div className="absolute inset-x-0 bottom-0 border-t border-navy-900/5 bg-white/90 p-5 backdrop-blur-md" data-id="element-529" data-mp="2eflv91vci1jo">
      <button type="button" onClick={onClick} disabled={disabled} className="flex h-14 w-full items-center justify-center gap-2 rounded-full bg-navy-900 text-[15px] font-semibold text-white transition hover:bg-navy-800 disabled:cursor-not-allowed disabled:bg-navy-900/25 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2" data-id="element-530" data-mp="20np4b15exxov">
        {label}
        <ArrowRightIcon className="h-4 w-4" style={{
        color: disabled ? undefined : accent
      }} data-id="element-531" data-mp="1hpl3qv3ld6yo" />
      </button>
    </div>;
}